<template>
  <transition
    enter-active-class="duration-300 ease-out"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="duration-200 ease-in"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-bsl="true"
      v-if="isShowing"
      class="fixed top-0 left-0 z-10 flex items-center justify-center w-screen h-screen p-6"
    >
      <!-- Shade -->
      <div class="fixed inset-0 transition-opacity bg-gray-faded" />
      <!-- Modal -->
      <transition
        enter-active-class="duration-300 ease-out"
        enter-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
        enter-to-class="translate-y-0 opacity-100 sm:scale-100"
        leave-active-class="duration-200 ease-in"
        leave-class="translate-y-0 opacity-100 sm:scale-100"
        leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
      >
        <!-- <div
          v-if="isShowing"
          class="p-6 overflow-hidden transition-all transform bg-white rounded-lg shadow-xl sm:p-6"
          aria-labelledby="modal-headline"
        > -->
        <div
          v-if="isShowing"
          class="w-20 h-20 border-4 border-teal-100 rounded-full loader"
        />
        <!-- </div> -->
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loader',
  components: {},
  mixins: [],
  props: {
    isShowing: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},

  // Lifecycle Hooks
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {}
}
</script>

<style scoped>
/* @keyframes rotating {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes rotating {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

.rotating {
  animation: rotating 2s linear infinite;
  -webkit-animation: rotating 2s linear infinite;
} */
.loader {
  border-top-color: #16bdca;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
